import {Component, Inject} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {
    MxCustomizer,
    MxFormCustomizerEvent,
    ObjectMetaData,
    OnBoFormMetadataReady, OnBoFormReady
} from 'mx-core';
import {PrlLanguageService} from '../../prl-language/services/prl-language.service';

@Component({
    selector: 'prl-change-password-dialog',
    templateUrl: './prl-change-password-dialog.component.html',
    standalone: false
})
export class PrlChangePasswordDialogComponent implements MxCustomizer<MxFormCustomizerEvent>, OnBoFormMetadataReady, OnBoFormReady {
    hidePassword: boolean = true;
    private form: FormGroup;
    private readonly languageService: PrlLanguageService;

    constructor(languageService: PrlLanguageService,
                @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.languageService = languageService;
    }

    onCustomize(event: any): any {
        event
            .customizeProps({
                showNavigation: false,
                showErrorOnSubmitInDialog: true,
                closeOnSubmit: true,
                informationKey: this.languageService.getLabel('label.modify.account.change.password')
            })
            .customizeActions(
                {
                    submit: {
                        text: this.languageService.getLabel('label.submit'),
                        visible: true
                    },
                    cancel: {
                        text: this.languageService.getLabel('label.cancel'),
                        visible: true
                    }
                })
            .customizeBoFormConfig({
                className: 'com.playtech.mexos.contract.account.ChangePasswordPrlObj',
                restLink: '/account/password/change',
                title: this.languageService.getLabel('label.modify.account.change.password'),
                formName: this.languageService.getLabel('label.modify.account.change.password')
            })
            .addCustomizer(this);
    }

    boOnMetadataReady(metaData: ObjectMetaData): ObjectMetaData {
        return ObjectMetaData.modifyFields(metaData,
            field => {
                if (field.name === 'oldPassword') {
                    field.validation.required = true;
                }
                return field;
            });
    }

    boOnFormReady(form: FormGroup): void {
        this.form = form;
    }

    isOldPasswordError(): boolean {
        return !!this.form.get(['oldPassword']).errors;
    }

    getLabel(label: string): string {
        return this.languageService.getLabel(label);
    }

}
